// Filename - GlobalShare.tsx
import React from "react";
import ShareModal from "./ShareModal";
import { useGlobalShare } from "./GlobalShareContext";

const GlobalShare: React.FC = () => {
  const { shareData, showShareModal, resetShare } = useGlobalShare();

  if (!shareData) return null;

  return (
    <ShareModal
      show={showShareModal}
      onClose={resetShare}
      shareData={shareData}
    />
  );
};

export default GlobalShare;
